function Error({ handleSubmit }) {
  return (
    <main>
      <section>
        <h2>An error occured. Please try again later</h2>
      </section>
    </main>
  );
}

export default Error;
